import { Dialog, Box, Button, Typography } from "@mui/material";

export const EmptyFilterComponent = ({
  openFilter,
  onCloseFilter,
  onCancel,
}: {
  openFilter: boolean;
  onCloseFilter: () => void;
  onCancel: () => void;
}) => (
  <Dialog
    open={openFilter}
    keepMounted
    maxWidth="sm"
    fullWidth
    onClose={onCloseFilter}
    aria-labelledby="mega-filter-empty-title"
  >
    <Box padding={3} textAlign="center">
      <Typography variant="h6" gutterBottom>
        No Filters Available
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{
        marginBottom: "16px"
      }}>
        There are no filters configured for this view.
      </Typography>
      <Button variant="contained" color="inherit" onClick={onCancel}>
        Close
      </Button>
    </Box>
  </Dialog>
);
